// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__jqytm","addBtnContainer":"AddDetails_addBtnContainer__LUxFT"};